<template>

<div class="ml-4">
    <span class="d-flex mr-4 mt-4 mb-8">
        <v-btn
        color="primary"
        class="white--text mt-1"
        @click="navigateBack()">
        <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer />
        <div class="ml-2 mt-2 text-h5 text-center">Scan Codes</div>
        <v-spacer />
    </span>
    <div>Unknown Egg Badges</div>
    <v-expansion-panels class="pt-2 pr-4 mb-5">
        <v-expansion-panel>
            <v-expansion-panel-header color="cardbackground">
                Bar Code
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap align-content-center class="mt-2">
                    <div class="mx-10 my-5 d-flex flex-wrap">
                        <div style="background-color:white;" >
                            <barcode :value="FLOOR_EGG" />
                        </div>
                    </div>
                    <div class="mx-10 my-5 d-flex flex-wrap">
                        <div style="background-color:white;" >
                            <barcode :value="NEST_EGG" />
                        </div>
                    </div>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
            <v-expansion-panel-header color="cardbackground">
                QR Code
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap align-content-center>
                    <div class="mx-10 my-5">
                        <div style="color:black; background-color:white;" class="pt-2 pb-0 px-4 my-3">
                             <qr-code :text="FLOOR_EGG" size="128" />
                            <div class="subtitle-2" style="text-align:center">{{ FLOOR_EGG }}</div>
                        </div>
                    </div>
                    <div class="mx-10 my-5">
                        <div style="color:black; background-color:white;" class="pt-2 pb-0 px-4 my-3">
                             <qr-code :text="NEST_EGG" size="128" />
                            <div class="subtitle-2" style="text-align:center">{{ NEST_EGG }}</div>
                        </div>
                    </div>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>

    <div>Pedigree Egg Grades</div>
    <v-expansion-panels class="pt-2 pr-4">
        <v-expansion-panel>
            <v-expansion-panel-header color="cardbackground">
                Bar Codes
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap align-content-center class="mt-2">
                    <div v-for="desc in pedigreeGradeDescs" :key="desc + 1" class="mx-10 my-5">
                        <div style="background-color:white;" >
                            <barcode :value="desc" />
                        </div>
                    </div>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
            <v-expansion-panel-header color="cardbackground">
                QR Codes
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap align-content-center>
                    <div v-for="desc in pedigreeGradeDescs" :key="desc" class="mx-10 my-5">
                        <div style="color:black; background-color:white;" class="pt-2 pb-0 px-4 my-3">
                            <qr-code :text="desc" size="128" />
                            <div class="subtitle-2" style="text-align:center">{{desc}}</div>
                        </div>
                    </div>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>

    <div class="mt-5">Super Sister Egg Grades</div>
    <v-expansion-panels class="pt-2 pr-4">
        <v-expansion-panel>
            <v-expansion-panel-header color="cardbackground">
                Bar Codes
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap align-content-center class="mt-2">
                    <div v-for="desc in superSisterGradeDescs" :key="desc + 1" class="mx-10 my-5">
                        <div style="background-color:white;" >
                            <barcode :value="desc" />
                        </div>
                    </div>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
            <v-expansion-panel-header color="cardbackground">
                QR Codes
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap align-content-center>
                    <div v-for="desc in superSisterGradeDescs" :key="desc" class="mx-10 my-5">
                        <div style="color:black; background-color:white;" class="pt-2 pb-0 px-4 my-3">
                            <qr-code :text="desc" size="128" />
                            <div class="subtitle-2" style="text-align:center">{{desc}}</div>
                        </div>
                    </div>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import VueQRCode from 'vue-qr-generator'
import { mapState } from 'vuex';
import eggPickerConstants from '../utils/eggPickerConstants';
export default {
  components: {
        'barcode': VueBarcode,
        'qr-code': VueQRCode
  },
  computed: {
    ...mapState(['settings']),
    pedigreeGradeDescs() {
        const gradeDescs = this.settings.eggGrades.filter(e=>e.isPedigree).map(e => `${e.descr.toUpperCase()} (${e.code[0]})`);
        return gradeDescs;
    },
    superSisterGradeDescs() {
        const gradeDescs = this.settings.eggGrades.filter(e=>e.isSuperSister).map(e => `${e.descr.toUpperCase()} (${e.code[0]})`);
        return gradeDescs;
    }
  },
  data() {
     return {
        FLOOR_EGG: eggPickerConstants.FLOOR_EGG,
        NEST_EGG: eggPickerConstants.NEST_EGG,
        pdfNames: ['Installation Instructions', 'Release Notes', 'Scan Codes']
    };
  },
  methods: {
    navigateBack() {
       this.$router.go(-1);
    },
  }
}
</script>